import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { ByTheNumbers } from '../components/ByTheNumbers';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-2397">
      <div className="dark" data-id="element-2398">
        <Hero data-id="element-2399" />
      </div>
      <WhyUs data-id="element-2400" />
      <ByTheNumbers data-id="element-2401" />
      <Services data-id="element-2402" />
      <HowItWorks data-id="element-2403" />
      <FAQ data-id="element-2404" />
      <Reviews data-id="element-2405" />
      <CtaBanner data-id="element-2406" />
    </main>;
}